import { getAllAssetPurchaseOrder } from '@api/services/asset-purchaase-order.service';
import { getAllClientInstallation } from '@api/services/client-installation.service';
import useDataQuery from 'modules/shared/hooks/use-data-query';

export const useAssetPurchaseOrderListData = (clientInstallationId: string, projectInstallationId: string) => {
    const purchaseOrderListQuery = useDataQuery(['purchase-orders', clientInstallationId, projectInstallationId], () =>
        getAllAssetPurchaseOrder(clientInstallationId, projectInstallationId)
    );

    return {
        purchaseOrderListData: purchaseOrderListQuery.data,
        isLoading: purchaseOrderListQuery.isLoading,
    };
};
